var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortBy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.394,
    height: 17,
    viewBox: "0 0 17.394 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.394,
    height: 17,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 17,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_12",
    "data-name": "Repeat Grid 12",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_163",
    "data-name": "Group 163",
    transform: "translate(-1593 -515)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_7",
    "data-name": "Repeat Grid 7",
    transform: "translate(1593 515)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1438 -510)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_38",
    "data-name": "Rectangle 38",
    transform: "translate(1438 510)",
    fill: "#fff",
    stroke: "#9d9d9d",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 7.2,
    height: 7.2,
    rx: 0.6,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1438 -501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_38-2",
    "data-name": "Rectangle 38",
    transform: "translate(1438 510)",
    fill: "#fff",
    stroke: "#9d9d9d",
    strokeWidth: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    rx: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 7.2,
    height: 7.2,
    rx: 0.6,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_162",
    "data-name": "Group 162",
    transform: "translate(0 -0.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1459.047,528.094l3.516,2.828,3.125-2.828",
    transform: "translate(144 1)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_21",
    "data-name": "Line 21",
    y2: 15,
    transform: "translate(1606.5 516.5)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M1459.047,530.922l3.516-2.828,3.125,2.828",
    transform: "translate(144 -12.094)",
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortBy);
export default __webpack_public_path__ + "static/media/sort-by.df2b1c305efa7ebc57fe22ae031705b4.svg";
export { ForwardRef as ReactComponent };